import cn from 'classnames';
import React from 'react';

import { useSelector } from 'editor/src/store/hooks';
import isPageCountOptionsEnabled from 'editor/src/store/hostSettings/selector/isPageCountOptionsEnabled';

import useTr from 'editor/src/util/useTr';

import { canShowAddRemovePages } from 'editor/src/component/TopMenuDesktop/buttons/ButtonAddPages';

import styles from './index.module.scss';

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

// Where a page change left the user. Shown only while the page count can change, so a product
// with a fixed page count carries no stray number.
function PageCounter({ className, style }: Props) {
  const tr = useTr();
  const pageCount = useSelector((state) => state.design.designData?.page_count);
  const enabled = useSelector(isPageCountOptionsEnabled);
  const canChange = useSelector(canShowAddRemovePages);

  if (!enabled || !canChange || !pageCount) {
    return null;
  }

  return (
    // The count changes away from the control that changed it, so screen readers are told.
    <div
      className={cn(styles.PageCounter, 'cy-page-counter', className)}
      style={style}
      role="status"
      aria-live="polite"
    >
      {tr('editor-page-counter', 'Pages: {{pageCount}}', { pageCount })}
    </div>
  );
}

export default React.memo(PageCounter);
